import React, { Component, memo } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import {
  Row,
  Col,
  Container,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Form
} from "reactstrap";
import classNames from "classnames";
import styled from "styled-components";
import _ from "lodash";

import axios from "axios"

import { API_BASE_URL } from '../../../constants'

import { getCollectionProductBrands } from "../../../actions/kafairAction";

import { Banner } from "../../../Container/Assets";
import SneakerImage from "../../../components/Sneakers/SneakerImage";
import SneakerLoadingSpinner from "../../../components/Sneakers/SneakerLoadingSpinner";
import { TextRupiah } from "../../../components/Text";
import { ASSET_IMAGE } from "../../../config";

import { getCloudImageUrl, normalizeBrand } from "../../../utils";
import NotFoundImg from "../../../images/dashboard-empty-state.png";

import SearchWhite from "../../../images/search-glass.png"
import SearchBlack from "../../../images/search-black.png"

const BannerList = (category) => {
  switch (category) {
    case "sneakers-bcaxkickavenue":
      // return `${ASSET_IMAGE}/banner/bcaxkickavenue/sneakers_web.png`;
      return `https://kickavenue-assets.s3-ap-southeast-1.amazonaws.com/banner/event/event-sneakers.png`;
    case "streetwear-bcaxkickavenue":
      // return `${ASSET_IMAGE}/banner/bcaxkickavenue/apparels_web.png`;
      return `https://kickavenue-assets.s3-ap-southeast-1.amazonaws.com/banner/event/event-streetwear.png`;
    case "luxury-bcaxkickavenue":
      // return `${ASSET_IMAGE}/banner/bcaxkickavenue/handbags_web.png`;
      return `https://kickavenue-assets.s3-ap-southeast-1.amazonaws.com/banner/event/event-luxury.png`;
    case "lifestyle-bcaxkickavenue":
      // return `${ASSET_IMAGE}/banner/bcaxkickavenue/lifestyles_web.png`;
      return `https://kickavenue-assets.s3-ap-southeast-1.amazonaws.com/banner/event/event-lifestyle.png`;

    default: return `https://kickavenue-assets.s3-ap-southeast-1.amazonaws.com/banner/event/event-sneakers.png`;
  }
};

const FilterButton = memo(({ item, onPress, isActive, buttonClick, category, mouseHover, mouseEnter, mouseLeave }) => {
  return (
    <Button
      // style={category === "lifestyles" || category === "handbags" ? { backgroundColor: "transparent", opacity: buttonClick === item.name ? "1" : null, width: "100%", borderBottom: "2px solid black"} : { backgroundColor: "transparent", opacity: buttonClick === item.name ? "1" : null, width: "100%", borderBottom: "2px solid white"}}
      style={category === "lifestyles" || category === "handbags" ? { backgroundColor: "transparent", opacity: buttonClick === item.name || mouseHover === item.name ? "1" : null, width: "100%", borderBottom: buttonClick === item.name || mouseHover === item.name ? "2px solid black" : "1px solid black" } : { backgroundColor: "transparent", opacity: buttonClick === item.name || mouseHover === item.name ? "1" : null, width: "100%", borderBottom: buttonClick === item.name || mouseHover === item.name ? "2px solid white" : "1px solid white" }}
      className="filter-price"
      onClick={onPress}
      onMouseEnter={mouseEnter}
      onMouseLeave={mouseLeave}
    >
      <p style={category === "lifestyles" || category === "handbags" ? { fontWeight: "bolder", color: "black", fontSize: "12px" } : { fontWeight: "bolder", color: "white", fontSize: "12px" }}>{item.text.includes(">=") && <span>&ge;</span>}{item.text.includes(">=") ? item.text.replace(">=", "") : item.text}</p>
    </Button>
  );
});

const TitleCategory = (slug) => {
  switch (slug) {
    case "sneakers-bcaxkickavenue":
      return "sneakers";
    case "streetwear-bcaxkickavenue":
      return "apparel";
    case "luxury-bcaxkickavenue":
      return "luxury";
    case "lifestyle-bcaxkickavenue":
      return "electronics-collectibles";

    default:
      return "sneakers";
  }
};

const CategoryName = (slug) => {
  switch (slug) {
    case "sneakers-bcaxkickavenue":
      return "sneakers";
    case "streetwear-bcaxkickavenue":
      return "apparels";
    case "luxury-bcaxkickavenue":
      return "handbags";
    case "lifestyle-bcaxkickavenue":
      return "lifestyles";

    default:
      return "sneakers";
  }
};

const CategoryImg = (slug) => {
  switch (slug) {
    case "sneakers-bcaxkickavenue":
      // return require("../../../images/sneakers.png");
      return "#24553e";
    case "streetwear-bcaxkickavenue":
      return require("../../../images/streetwear.png");
    case "luxury-bcaxkickavenue":
      return require("../../../images/luxury.png");
    case "lifestyle-bcaxkickavenue":
      return require("../../../images/lifestyle.png");
    default:
      return require("../../../images/sneakers.png");
  }
};

const BackgroundColor = (slug) => {
  switch (slug) {
    case "sneakers-bcaxkickavenue":
      return "#24553e";
    case "streetwear-bcaxkickavenue":
      return "#9B2520";
    case "luxury-bcaxkickavenue":
      return "#FCFBEE";
    case "lifestyle-bcaxkickavenue":
      return "#FFDF37";
    default:
      return "#24553e";
  }
}

class CategorySectionProduct extends Component {
  constructor(props) {
    super(props);
    const { computedMatch } = this.props;
    const slug = computedMatch.params.section || "sneakers-bcaxkickavenue";
    const name =
      (computedMatch.params.section &&
        computedMatch.params.section.replace("-", "_")) ||
      "sneakers-bcaxkickavenue";
    const title = TitleCategory(
      computedMatch.params.section || "sneakers-bcaxkickavenue"
    );
    const category = CategoryName(
      computedMatch.params.section || "sneakers-bcaxkickavenue"
    );
    const icon = CategoryImg(
      computedMatch.params.section || "sneakers-bcaxkickavenue"
    );
    const backgroundColor = BackgroundColor(computedMatch.params.section || "sneakers-bcaxkickavenue")

    const bannerCategory = BannerList(computedMatch.params.section || "sneakers-bcaxkickavenue");

    this.state = {
      page: 1,
      prevY: 0,
      currentSlug: "",
      title,
      name,
      brandId: null,
      category,
      slug,
      icon,
      backgroundColor,
      selectedPrice:
        this.props.history.location.state &&
          this.props.history.location.state.namePrice
          ? this.props.history.location.state &&
          this.props.history.location.state.namePrice
          : "show_all",
      start_price:
        this.props.history.location.state &&
          this.props.history.location.state.start_price
          ? this.props.history.location.state &&
          this.props.history.location.state.start_price
          : 0,
      end_price:
        this.props.history.location.state &&
          this.props.history.location.state.end_price
          ? this.props.history.location.state &&
          this.props.history.location.state.end_price
          : 0,
      bannerCategory,
      filterListSneakers: [
        {
          name: "low_price",
          text: "< 1 juta",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: 0,
          end_price: 999999,
          isActive: false
        },
        {
          name: "middle_price",
          text: "1 juta-an",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 1000000,
          end_price: 1999999,
          isActive: false
        },
        {
          name: "high_price",
          text: "2 juta-an",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 2000000,
          end_price: 2999999,
          isActive: false
        },
        {
          name: "super_high_price",
          text: "3 juta-an",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 3000000,
          end_price: 3999999,
          isActive: false
        },
        {
          name: "extra_high_price",
          text: "4 juta-an",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 4000000,
          end_price: 4999999,
          isActive: false
        },
        {
          name: "extreme_high_price",
          text: ">= 5 juta",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 5000000,
          end_price: 29999999999999,
          isActive: false
        },
        {
          name: "",
          text: "Show All",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 0,
          end_price: 0,
          isActive: false
        }
      ],
      filterListLuxury: [
        {
          name: "low_price",
          text: "< 2 juta",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: 0,
          end_price: 2999999,
          isActive: false
        },
        {
          name: "middle_price",
          text: "2-5 juta",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 3000000,
          end_price: 8999999,
          isActive: false
        },
        {
          name: "high_price",
          text: "5-10 juta",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 8000000,
          end_price: 5000000000,
          isActive: false
        },
        {
          name: "super_high_price",
          text: ">10 juta",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 8000000,
          end_price: 5000000000,
          isActive: false
        },
        {
          name: "",
          text: "Show All",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 0,
          end_price: 0,
          isActive: false
        }
      ],
      filterListLifestyle: [
        {
          name: "funko-pop",
          text: "FUNKO POP",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: 0,
          end_price: 100000000000,
          isActive: false
        },
        {
          name: "games-consoles",
          text: "GAMES & CONSOLES",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 1000000,
          end_price: 100000000000,
          isActive: false
        },
        {
          name: "supreme-lifestyles",
          text: "SUPREME",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 1000000,
          end_price: 100000000000,
          isActive: false
        },
        {
          name: "casio",
          text: "G-SHOCK",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 0,
          end_price: 100000000000,
          isActive: false
        },
        {
          name: "",
          text: "Show All",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 0,
          end_price: 0,
          isActive: false
        },
      ],
      searchInput: "",
      buttonClick: this.props.history.location.state && this.props.history.location.state.filterPrice || "",
      brandId: this.props.history.location.state && this.props.history.location.state.brandId || null,
      buttonText: null,
      mouseHover: false
    };

    this.onApplySearch = _.debounce(this.onSubmitSearch, 1000)
  }

  async componentDidMount() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.6
    };

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    if (this.state.category === 'lifestyles') {
      const { data: { data: { brands } } } = await axios.get(`${API_BASE_URL}/collections/all/harbolkick-lifestyles-brand`)

      const data = this.state.filterListLifestyle.map(item => {
        const brand = brands.data.find(brand => item.name === brand.slug)
        if (brand) {
          return {
            ...item,
            text: brand.title && brand.title !== '' ? brand.title : brand.name,
            id: brand.id
          }
        }
        return item;
      })
      await this.setState({
        filterListLifestyle: [...data]
      })
    }
    try {
    } catch (error) {
      this.setState({ fetchBrandError: true })
    }
    this.getProductList();

    this.observer = new IntersectionObserver(
      this.handleObserver.bind(this),
      options
    );
    this.observer.observe(this.loadingRef);
  }

  componentDidUpdate(prevProps) {
    const { dataCategory, scrollTo, computedMatch } = this.props;
    const { page } = this.state;

    if (
      !dataCategory.isFetching &&
      prevProps.dataCategory.isFetching !== dataCategory.isFetching
    ) {
      const { status_code, error } = dataCategory;

      if (!error && status_code === 200) {
        this.setState({
          page: page + 1,
        });
      }
    }

    if (prevProps.scrollTo !== scrollTo) {
      this.setState({
        title: TitleCategory(computedMatch.params.section),
        category: CategoryName(computedMatch.params.section),
        icon: CategoryImg(computedMatch.params.section),
        backgroundColor: BackgroundColor(computedMatch.params.section),
        bannerCategory: BannerList(computedMatch.params.section),
        page: 1,
        selectedPrice: "show_all",
        name: (computedMatch.params.section &&
          computedMatch.params.section.replace("-", "_")) ||
          "sneakers-bcaxkickavenue"
      }, () => {
        this.getProductList();
      });
    }
  }

  handleObserver(entities, observer) {
    const { prevY, page } = this.state;
    const { hasMoreData } = this.props.dataCategory;

    const y = entities[0].boundingClientRect.y;
    if (hasMoreData !== null) {
      if (prevY > y) {
        this.getProductList();
      }
      this.setState({ prevY: y });
    }
  }

  getProductList = () => {
    const { category, name, page, start_price, end_price, searchInput, brandId, buttonText } = this.state;


    const payloadProducts = {
      page,
      per_page: 16,
      category,
      // start_price,
      // end_price,
      keyword: searchInput
    };

    if (this.state.category !== 'lifestyles') {
      payloadProducts.start_price = start_price;
      payloadProducts.end_price = end_price;
    } else if (this.state.category === 'lifestyles') {
      if (brandId)
        payloadProducts.brands = brandId
      else
        payloadProducts.keyword = buttonText
    }

    this.props.getCollectionProductBrands(payloadProducts, name);
  };

  goToProductDetail = (id, category, slug) => {
    this.props.history.push(`/${category}/${id}/${slug}`);
  };

  onApplyFilter = (selectedName, data) => {
    this.setState(
      {
        selectedPrice: selectedName,
        page: 1,
        start_price: selectedName === "" ? 0 : data.start_price,
        end_price: selectedName === "" ? 0 : data.end_price,
        buttonClick: selectedName,
        buttonText: selectedName === "" ? null : data.text,
        brandId: data.name === "" ? null : data.id
      },
      () => {
        this.getProductList();
      }
    );
  };

  toogleMouseHover = (data) => {
    this.setState({
      mouseHover: data
    })
  }

  onSubmitSearch = (e) => {
    e.preventDefault();
    this.setState({ page: 1 }, () => this.getProductList())
  }

  inputHandler = (e) => {
    this.setState({ searchInput: e.target.value });
    this.onApplySearch(e);
  }

  onResetSearch = () => {
    this.setState({ searchInput: "", page: 1 }, () => this.getProductList())
  }

  renderList = () => {
    const { productList, error } = this.props.dataCategory;
    const { category } = this.state;

    if (productList.length === 0) return null;

    return (
      <Row className="product-wrapper">
        {error ? (
          <p style={{ fontSize: "14px", color: this.state.category === "handbags" || this.state.category === "lifestyles" ? "black" : "white", fontWeight: "bold", marginTop: "50px" }}>No products available</p>
        ) : (
          productList?.map((item, index) => (
            <Col xs={6} md={3}>
              <a
                href={`/${item.product.category.name}/${item.id}/${item.slug}`}
                style={
                  !item.price || item.out_of_stock
                    ? {
                      pointerEvents: "none",
                    }
                    : {}
                }
              >
                <div
                  className={classNames("product-card", {
                    disabled: !item.price || item.out_of_stock,
                  })}
                >
                  <span>
                    {normalizeBrand(
                      item.product.brand && item.product.brand.title
                        ? item.product.brand && item.product.brand.title
                        : item.product.brand && item.product.brand.name
                    )}
                  </span>
                  <span>{item.display_name}</span>
                  <SneakerImage
                    hasImage={
                      item.product_variant_images.length > 0 ? true : false
                    }
                    src={
                      item.product_variant_images.length
                        ? getCloudImageUrl(
                          item.product_variant_images[0].URL,
                          400
                        )
                        : null
                    }
                    alt={item.display_name}
                    category={category}
                  />
                  {item.price ? (
                    <TextRupiah
                      value={item.price}
                      className="price-tag"
                      color="black"
                      bold={true}
                      align="center"
                    />
                  ) : (
                    <span className="text-center">X</span>
                  )}
                </div>
              </a>
            </Col>
          ))
        )}
      </Row>
    );
  };

  renderSection = () => {
    const { dataCategory } = this.props;
    const { productList } = dataCategory;

    return (
      <div className="steal-product-container">
        <Container>
          {this.renderList()}
          <div style={{ marginTop: "80px" }}>
            <SneakerLoadingSpinner
              isLoading={
                dataCategory.isFetching ||
                (dataCategory.isFetching && this.state.page > 1)
              }
              isHide={!dataCategory.isFetching}
              wrapperRef={(loadingRef) => (this.loadingRef = loadingRef)}
            />
          </div>
        </Container>
      </div>
    );
  };

  render() {
    const { dataCategory, computedMatch: { params: { section } } } = this.props;
    const { icon, title, filterListSneakers, category, filterListLuxury, filterListLifestyle, buttonClick, backgroundColor, bannerCategory } = this.state;

    return (
      <Container fluid className="main-container" id="home-container" style={{ backgroundColor: `${backgroundColor}`, marginTop: window.screen.availWidth > 780 ? "-70px" : null }}>
        <Banner src={getCloudImageUrl(bannerCategory, 1024)} alt={section} />
        <Col style={{ backgroundColor: `${backgroundColor}`, backgroundSize: "cover", backgroundPosition: "center" }} md={12} xs={12}>
          <div className="steal-product-container">
            <Container>
              <div className="header-wrapper">
                <div className="title-wrapper">
                </div>
                <SearchWrapper isBlackBorder={category === "lifestyles" || category === "handbags"}>
                  <Form className="search" onSubmit={this.onSubmitSearch}>
                    <div className="search">
                      <KickImage alt="Search icon" className="fa-search" src={category === "sneakers" || category === "apparels" ? SearchWhite : SearchBlack} />
                      <input
                        placeholder="Search for any products here"
                        value={this.state.searchInput}
                        name="searchInput"
                        onChange={this.inputHandler}
                        className={classNames({ "white": category === "sneakers" || category === "apparels" }, { "black": category === "lifestyles" || category === "handbags" })}
                      />
                    </div>
                  </Form>
                  <div className="reset" onClick={this.onResetSearch}>
                    <p style={{ color: category === "sneakers" || category === "apparels" ? "#FFF" : "#000", fontWeight: "bold", marginTop: "15px" }}>Reset</p>
                  </div>
                </SearchWrapper>
              </div>
              <div className="header-wrapper filter">
                {
                  category === "handbags" ? filterListLuxury.map((item) => {
                    return (
                      <FilterButton
                        key={item.name}
                        item={item}
                        onPress={() => this.onApplyFilter(item.name, item)}
                        buttonClick={this.state.buttonClick}
                        mouseEnter={() => this.toogleMouseHover(item.name)}
                        mouseLeave={() => this.toogleMouseHover(false)}
                        mouseHover={this.state.mouseHover}
                        category={category}
                        slug={section}
                      />
                    )
                  }) : category === "lifestyles" ? filterListLifestyle.map((item) => {
                    return (
                      <FilterButton
                        key={item.name}
                        item={item}
                        onPress={() => this.onApplyFilter(item.name, item)}
                        buttonClick={this.state.buttonClick}
                        mouseEnter={() => this.toogleMouseHover(item.name)}
                        mouseLeave={() => this.toogleMouseHover(false)}
                        mouseHover={this.state.mouseHover}
                        category={category}
                        slug={section}
                      />
                    )
                  }) : filterListSneakers.map((item) => {
                    return (
                      <FilterButton
                        key={item.name}
                        item={item}
                        onPress={() => this.onApplyFilter(item.name, item)}
                        buttonClick={this.state.buttonClick}
                        mouseEnter={() => this.toogleMouseHover(item.name)}
                        mouseLeave={() => this.toogleMouseHover(false)}
                        mouseHover={this.state.mouseHover}
                        slug={section}
                        category={category}
                      />
                    )
                  })
                }
              </div>
            </Container>
          </div>
          {this.renderSection()}
        </Col>
      </Container>
    );
  }
}

const SearchWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  
  .reset {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 35px;
    border: ${props => props.isBlackBorder ? "1px solid rgba(0, 0, 0, 0.5)" : "1px solid rgba(247, 247, 247, 0.5)"};
    border-radius: 3px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    margin-left: 5px;
    padding: 0 5px;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      object-fit: content;
    }
  }
`

const mapStateToProps = (state, ownProps) => {
  const name =
    ownProps.computedMatch.params.section &&
    ownProps.computedMatch.params.section.replace("-", "_");

  return {
    dataCategory: state.dataKaFair[name],
    scrollTo: state.dataKaFair.scroll_to,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCollectionProductBrands: (payload, name) =>
    dispatch(getCollectionProductBrands(payload, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategorySectionProduct);